import React, { useRef } from 'react'; 
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import {
    landingPageTiles,
} from "../../../utils/landingPage.utils";
import { LandingTile } from '../../../types/landingPage';
import { Link } from "gatsby";
import { buildAppUrl } from "../../../utils/buildAppUrl";
import { useSiteMetadataVersions } from "../../../queries/useSiteMetadataVersions";
import { useCurrentPath } from "../../../contexts/useCurrentPath";


const GuideScroller = ()  => {
    const { latestVersion } = useSiteMetadataVersions();
    const containerRef = useRef<HTMLDivElement>(null);
    const currentPath = useCurrentPath();

    function getTileURL(tile: LandingTile, version?: string): string {
        return buildAppUrl({
            version,
            latestVersion,
            title: tile.titleSlug,
            permalink: tile.permalink,
            path: tile.path,
            slug: tile.titleSlug,
        });
    }

    return (
        <div className="flex md:hidden justify-center items-center space-x-4 mx-8 mb-4 mt-4">
            {/* Left arrow */}
            <button
                className="h-8 w-8 bg-medium-dark-grey text-soft-blue-grey p-0 flex items-center justify-center rounded-full flex-shrink-0  shadow-md hover:text-vivid-orange"
                onClick={() => {
                    if (containerRef.current) {
                        containerRef.current.scrollBy({ left: -144, behavior: 'smooth' });
                    }
                }}
            >
                <FaChevronLeft className="h-3 w-3" />
            </button>

            {/* Guide Scroller - Snap scroll container */}
            <div
                ref={containerRef}
                className="flex w-full overflow-x-auto snap-x space-x-4 hide-scrollbar"
            >
                {landingPageTiles.map((tile, tileIndex) => {
                    return (
                        <div key={`t-${tile.path}-${tileIndex}`} className={`items-center w-36 h-12 space-x-1 flex-shrink-0 border border-medium-dark-grey rounded-lg  ${currentPath === tile.path ? 'border-vivid-orange' : 'border-medium-dark-grey'}`}>
                            <Link
                                to={getTileURL(tile)}
                                className="flex flex-row items-center justify-center h-full w-full overflow-x-auto snap-x hide-scrollbar text-soft-blue-grey hover:text-vivid-orange"
                            >
                                <img
                                    className="object-contain max-h-6 max-w-6 mx-1 m-0.5"
                                    src={tile.icon}
                                    alt={tile.title}
                                />
                                <h2 className="text-sm text-inherit text-center mx-1 !p-0.5">
                                    <span className="text-bright-white">
                                        {tile.title}
                                    </span>
                                </h2>
                            </Link>
                        </div>
                    )
                })}
            </div>

            {/* Right arrow */}
            <button
                className="h-8 w-8 bg-medium-dark-grey text-soft-blue-grey p-0 flex items-center justify-center rounded-full flex-shrink-0  shadow-md hover:text-vivid-orange"
                onClick={() => {
                    if (containerRef.current) {
                        containerRef.current.scrollBy({ left: 144, behavior: 'smooth' });
                    }
                }}
            >
                <FaChevronRight className="h-3 w-3" />
            </button>
        </div>
    );
};

export default GuideScroller;